export const POLICY_PATTERN = /^[A-Z]{2}[\d]{6}(-\d+)?$/;

export const DIGITS_PATTERN = /^[0-9]+$/;

export const NON_DIGITS_PATTERN = /[^0-9]/g;

export const EMPTY_NUMBER_FIELD_VALUE = 0;

export const ONLY_LETTERS_AND_NUMBERS_REGEX = /^[a-zA-Z0-9]+$/;

export const ONLY_DIGITS_REGEX = /^\d/;
export const ONLY_DIGITS_REGEX_ALT = /^$|^\d+$/;
export const ONLY_DIGITS_AND_ASTERISK = /^\d+\*+\d+$/;

export const STRICT_DIGITS_REGEX = /^\d*$/;
export const EIGHT_DIGITS_REGEX = /^[\d]{8}$/;

export const ARMENIAN_NON_BIOMETRIC_PASSPORT_REGEX = /^[A-Z]{2}\d{7}$/;

export const ARMENIAN_BIOMETRIC_PASSPORT_REGEX = /^\d{9}$/;

export const ANY_LETTER_REGEX = /[a-zA-Z]/;
export const RECURRING_POLICY_PATTERN = /(^[a-zA-Z]{2}\/\d{6}$)/;

export const MATCHES_STRINGS_WITH_ZERO_OR_MORE_DIGITS = /^\d+$/;

export const EMAIL_VALIDATION_PATTERN = /^[A-Z0-9._%+*-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
